module.exports = __webpack_public_path__ + "static/media/FLR_Wallpaper01_Mobile.5b033b21.jpg";